import { render, staticRenderFns } from "./DataOverview.vue?vue&type=template&id=57ff1fdc&scoped=true&"
import script from "./DataOverview.vue?vue&type=script&lang=js&"
export * from "./DataOverview.vue?vue&type=script&lang=js&"
import style0 from "./DataOverview.vue?vue&type=style&index=0&id=57ff1fdc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ff1fdc",
  null
  
)

export default component.exports